import { useState } from 'react';
import { motion } from 'framer-motion';
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../hooks';
import { AppSettings } from '../../types';
import { saveAppSettings, resetAppSettings, checkForUpdate } from '../../utils/NativeWebView';
import { cardInOut } from '../../animations/PageAnimations';
import { logClickEvent } from "../../utils/NativeWebView";

const Settings = () => {

  const navigate = useNavigate();

  const [hideBtnUpdate, setHideBtnUpdate] = useState(false);

  const { locations } = useAppSelector( state => state.webSettings );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<AppSettings>();

  let appType, branch, user, latLong;
  if (window.appSettings && window.appSettings.status === 'ok') {
    appType = window.appSettings.appType;
    branch = window.appSettings.branch;
    latLong = window.appSettings.branchLatLong;
    user = window.appSettings.user;
  }
  const updateId = window.updateId;
  const deviceID = window.deviceID;

  const handleResetAppSettings = () => {
    logClickEvent('reset', 'click_settings', 'choice', 'Reset');
    resetAppSettings();
  };

  const onSubmit: SubmitHandler<AppSettings> = (data:AppSettings) => {
    const branchData = locations.find(location => String(location.id) === data.branch);
    const branchName = branchData ? branchData.name : '';
    const branchLatLong = branchData ? `${branchData.lat}, ${branchData.long}` : '';

    window.appSettings = {
      status: 'ok',
      ...data,
      branchName,
      branchLatLong
    };
    logClickEvent('guardar', 'click_settings', 'choice', 'Guardar');
    saveAppSettings({ ...data, branchName, branchLatLong });
    navigate('/');
  };

  const handleCheckForUpdate = () => {
    setHideBtnUpdate(true);
    checkForUpdate();
  };

  return (
    <section className="flex items-center justify-center mt-24 p-12">
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        key="settings-form"
        custom={2}
        variants={cardInOut}
        className="relative w-[600px] rounded-2xl border-2 border-orange bg-white p-8 drop-shadow-xl"
      >
        <h1>Settings</h1>
        <p className="text-2xl">Configuración de la aplicación.</p>

        <p className="my-2 text-grayvars-600">DEVICE ID: <span className="text-grayvars-700">{deviceID}</span></p>
        <p className="my-2 text-grayvars-600">Lat/Long: <span className="text-grayvars-700">{latLong}</span></p>
        <p className="my-2 text-grayvars-600">UPDATE ID: <span className="text-grayvars-700 mr-2">
          {updateId}
        </span>
        { !hideBtnUpdate && <button
          type="button" onClick={handleCheckForUpdate}
          className="uppercase rounded-full py-1 px-4 text-xs text-purple bg-white border-purple border-solid border"
        >
          Check update
        </button> }
        </p>

        <form className="flex flex-col" onSubmit={handleSubmit(onSubmit)}>

          <label className="mt-4 block">
            <span className="text-grayvars-900">Seleccionar sucursal:</span>
            <select
              {...register("branch", {  required: "Field required." })}
              className="border-transparent mt-1 block w-full rounded-md bg-grayvars-100 focus:border-orange focus:bg-white focus:ring-0"
              defaultValue={branch}
            >
              <option value="">Seleccionar</option>
              { locations.map( location =>
                <option key={location.id} value={location.id}>{location.name}</option>
              )}
              <option value="other">Otra</option>
            </select>
          </label>

          <label className="mt-4 block">
            <span className="text-grayvars-900">App Type:</span>
            <select
              {...register('appType', { required: 'Field required.' })}
              className="border-transparent mt-1 block w-full rounded-md bg-grayvars-100 focus:border-orange focus:bg-white focus:ring-0"
              defaultValue={appType}
            >
              <option value="clients">Clientes</option>
              <option value="internal">Internal</option>
              <option value="development">Development</option>
            </select>
          </label>

          <label className="mt-4 block">
            <span className="text-grayvars-900">Usuario:</span>
            <input
              defaultValue={user}
              type="text"
              id="user"
              {...register('user')}
              className="border-transparent focus:border-gray-500 mt-1 block w-full rounded-md focus:border-orange focus:bg-white focus:ring-0"
            />
            <span className="text-grayvars-600 text-sm">{errors.user?.message}</span>
          </label>

          <div className="mt-12 mb-2 flex justify-start">
            <input
              className="w-44 rounded-full py-3 px-4 bg-purple text-white"
              type="submit"
              value="Guardar"
            />
            <button type="button" onClick={handleResetAppSettings} className="ml-4 w-44 rounded-full py-3 px-4 text-purple bg-white border-purple border-solid border">
              Reset
            </button>
          </div>
        </form>
      </motion.div>
    </section>
  );
};

export default Settings;
